<template>
  <div
    class="banner"
    :style="{
      background: `url(${itemData.backgroundUrl}?x-oss-process=image/resize,w_750/quality,q_80) top center / 100% 100%`,
      padding: `${computedStyle(itemData.padding.top)}px ${computedStyle(
        itemData.padding.right
      )}px ${computedStyle(itemData.padding.bottom)}px ${computedStyle(
        itemData.padding.left
      )}px`,
    }"
  >
    <van-swipe class="banner-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item
        v-for="(item, index) in itemData.banner.imgList"
        :key="index"
      >
        <van-image
          :src="item + '?x-oss-process=image/resize,w_750/quality,q_80'"
        ></van-image>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  props: {
    itemData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {
    computedStyle(num) {
      return (num * document.documentElement.clientWidth) / 323;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  :deep(.van-image) {
    width: 100%;
    height: 100%;
    display: block;
    text-align: center;
  }
  .el-icon-picture-outline {
    font-size: 50px;
    color: #ccc;
  }
}
</style>
